var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.35 54.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00a94f;}.cls-2{fill:#c0c6ca;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M667.12,668.34c4.62,2.77,20,9.24,18.79,14.48-1.23,5.85-16.94,10.16-20.63,11.39-1.85-4-1.54-22.48,1.54-25.56",
    transform: "translate(-659.63 -667.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M663.85,669.32c8.27,3.83,15.29,9.77,22.08,15.75l.66-1.53a157.84,157.84,0,0,0-22.23,7.29c-1.46.61-.17,2,1.06,1.46A153,153,0,0,1,687,685.22c.68-.17,1.32-1,.66-1.53-6.93-6.11-14.09-12.09-22.53-16-1-.48-2.67,1-1.32,1.63",
    transform: "translate(-659.63 -667.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M661.64,668.27c-2.86,16.19.15,32.08,4.16,47.79.21.83,2.53.21,2.32-.62-4-15.61-7-31.37-4.16-47.46.16-.91-2.18-.52-2.32.29",
    transform: "translate(-659.63 -667.46)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M662.1,715.39a26.22,26.22,0,0,1,8.26-1.56c1.28,0,2.82.06,3.7,1.11.71.85.2,2.85-.54,3.52-1.85,1.69-5.45,2.12-7.82,2.17a4.42,4.42,0,0,1-3.37-1c-1-1-.05-2.71.49-3.67.29-.51-1.94-.32-2.31.34-.73,1.3-1.37,2.88-.34,4.19s2.93,1.27,4.28,1.3c3.5.1,7.89-.85,10.75-3a4.15,4.15,0,0,0,1.4-4.05c-.39-1.53-2.42-1.92-3.74-2.06a27.43,27.43,0,0,0-11.63,1.88c-1.54.57-.11,1.14.87.79",
    transform: "translate(-659.63 -667.46)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.ab22565d.svg";
export { ForwardRef as ReactComponent };